import { render, staticRenderFns } from "./flashSale.vue?vue&type=template&id=d6e10898&scoped=true"
import script from "./flashSale.vue?vue&type=script&lang=js"
export * from "./flashSale.vue?vue&type=script&lang=js"
import style0 from "./flashSale.vue?vue&type=style&index=0&id=d6e10898&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6e10898",
  null
  
)

export default component.exports